export default __webpack_public_path__ + "static/media/ga-login0.a2a01ba6.svg";